import { createRoot } from "react-dom/client";
import React, { ReactNode, useState } from "react";
import { CELL_SIZE } from "./grid/constants";
import { useProgram, withProgramContext } from "./program/ProgramContext";
import { observer } from "mobx-react-lite";
import { Palette } from "./palette/Palette";
import { Workspace } from "./workspace/Workspace";

const App = observer(() => {
  const program = useProgram();

  return (
    <main style={{ display: "flex", gap: CELL_SIZE }}>
      <Palette />
      <Workspace />
      <div>
        <h2>Evaluation</h2>
        <div>Mana: {program.mana}</div>
        <div>Flux: {program.flux}</div>
        <ul>
          {program.reference.map((item, index) => (
            <li key={item + "." + index}>{item}</li>
          ))}
        </ul>
      </div>
    </main>
  );
});
const AppWithProgram = withProgramContext(App);

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing in index.html");
}

const root = createRoot(container);
root.render(<AppWithProgram />);
